import { NAMESPACE } from "@modules/editor/service/editor.constant";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(NAMESPACE.LESSON, [
      "updateCourseAndSectionCoverVisibility",
      "updateSectionCoverVisibility",
    ]),
    postAddSectionToast(showCover, showSectionCover) {
      if (!showCover) {
        this.updateCourseAndSectionCoverVisibility(true);
        this.$toast.show("info", {
          title: this.$i18n.t("lesson_editor_introduction_page_section_cover_added_message"),
        });
        return;
      }

      if (!showSectionCover) {
        this.updateSectionCoverVisibility(true);
        this.$toast.show("info", {
          title: this.$i18n.t("lesson_editor_section_cover_added_message"),
        });
      }
    },
  },
};
